export type EoiCardProps = {
  
};

export enum EOIScreens {
    LOADING = "LOADING",
    PROJECT_LISTING = "PROJECT_LISTING",
    CREATE_REQUEST = "CREATE_REQUEST",
    DOCUSIGN_LOADING = "DOCUSIGN_LOADING",
    DOCUSIGN_STATUS = "DOCUSIGN_STATUS",
    PAYMENT = "PAYMENT",
    PAYMENT_STATUS= "PAYMENT_STATUS",
}

export enum NavigationActions {
  CLOSE = "CLOSE",
  BACK = "BACK",
  GOTO_LISTING = "GOTO_LISTING"
}

export type EoiProject = {
  projectId: string;
  projectIconURL: string;
  projectBgURL: string;
  userCount: number;
  projectName: string;
  projectLocation: string;
};

export type ProjectCardProps = EOIProjectType & {
  projectStartingPrice?: number;
  projectIconURL?: string;
  paymentDetails?: PaymentDetailsType | null;
  onSelect: (projectId: string) => void;
};

export type EoiProps = {
  onClose: () => void;
};

export type ProjectListingProps = {
  isLoading: boolean;
  onSelectProject: (projectId: EOIProjectType) => void;
};

export type CreateRequestProps = {
  onScreenChange: (screen: EOIScreens) => void;
};

export type DocumentSigningProps = {
  onScreenChange: (screen: EOIScreens) => void;
};

export type PaymentProps = {};

export type GenericLoaderProps = {
  message?: string;
};

export type ImageCarouselProps = {
  images?: string[];
  title?: string;
  location?: string;
};

export type PaymentStatusProps = {
  onClose: () => void;
};

/**
 * Generic envelope returned by EOI endpoints (the `response.data` shape)
 */
export interface EOIApiResponse<T> {
  statusCode: number;
  data: T;
}

/**
 * Shape of `response.data.data` returned by createUpdateEOI
 * (consumed in CreateRequest via { paymentDetails, documentDetails, customerEOIDetails })
 */
export interface CreateUpdateEOIResponseData {
  paymentDetails?: PaymentDetailsType | null;
  documentDetails?: DocumentDetailsType | null;
  customerEOIDetails?: CustomerEOIDetailsType | null;
}

/**
 * Payload type for fetching EOI property list
 */
export interface GetEOIPropertyListPayload {
  customerId: string;
  referenceId: string;
}

/**
 * Payload type for creating or updating an EOI
 */
export interface CreateUpdateEOIPayload {
  customerId: string;
  referenceId: string;
  projectId: string;
  unitType: string;
  numberOfBedrooms: string;
  customerRemarks?: string;
  eoiId?: string;
  salesManagerId?: string;
  status?: string;
}

export type BrokerDetailsType = {
  name: string;
  email: string;
  phone: string;
  brokerId: string;
  brokerAgencyEmail: string;
  brokerAgencyId: string;
  brokerAgencyName: string;
  brokerAgencyPhone: string;
}  
export type SalesManagerDetailsType = {
  salesManagerId: string | null;
  name: string | null;
  email: string | null;
  phone: string | null;
};

export type CustomerEOIDetailsType = {
  unitType: string;
  numberOfBedrooms: string;
  name: string;
  id: string;
  customerRemarks: string;
  createdDate: string;
  source?: string;
  status?: string;
  brokerDetails?: BrokerDetailsType | null;
  salesManagerDetails: SalesManagerDetailsType | null;
};

export type DocumentDetailsType = {
  documentStatus: string;
  documentId: string;
};


export type PaymentDetailsType = {
  status: string;
  reservationAmount: number;
  paymentId: string;
  paidAmount: number;
  currencyCode?: string;
};

export type FormattedPaymentSummaryItem = {
  description: string;
  amount: number;
  currency: string;
};

export type FormattedPaymentDetailsType = null | {
  amount: number;
  currency: string;
  paymentId: string;
  summary: FormattedPaymentSummaryItem[];
};
export interface PaymentHistoryItem {
  status: string;
  receiptNumber: string;
  receiptId: string;
  paymentReferenceNo: string;
  paidDate: string;
  amountPaid: number;
}
export interface EOIProjectType {
  projectName: string;
  projectId: string;
  projectCountry: string;
  projectCity: string;
  currencyCode: string;
  paymentHistory: PaymentHistoryItem[] | null;
  paymentDetails: PaymentDetailsType | null;
  numberOfUsersSecured: number;
  documentDetails: DocumentDetailsType | null;
  customerEOIDetails: CustomerEOIDetailsType | null;
  availableUnitTypes: string[];
  availableBedrooms: string[];
  heroImage: string;
}

export interface EOIChipOptionsType {
  id: string,
  selected: boolean;
}

export interface ExpressionOfInterestState {
  currentPage: EOIScreens;
  selectedProject: EOIProjectType | null;
  allProjects: EOIProjectType[];
  source?: string;
}

export enum chipOptionKey {
  availableUnitTypes = "availableUnitTypes",
  availableBedrooms = "availableBedrooms"
}